import { useContext, useEffect } from 'react';
import { get } from 'lodash';
import { useProjectModulesQuery } from '~/hooks/use-project-modules';
import { useAppUser } from '~/components/molecules/appuser/appuser-context';
import { EnvProviderContext } from '~/hooks/use-env-provider';
import { ProjectAppTypes } from '~/types';

export interface TwxEnabled {
  twxEnabled: boolean;
  twxLoading: boolean;
}

export function useTwxEnabled(): TwxEnabled {
  const { user } = useAppUser();
  const [getModules, { data: moduleData, loading: twxLoading }] = useProjectModulesQuery();
  // read the context directly since useEnvProvider() throws outside an EnvProvider
  const envProviderContext = useContext(EnvProviderContext);
  const isASAppType = envProviderContext?.envConfig?.appName === ProjectAppTypes.AS;

  useEffect(() => {
    if (!user || !user.project || !user.project.id) return;
    getModules({ variables: { id: user?.project?.id } });
  }, [getModules, user]);

  const twxEnabled = isASAppType && Boolean(get(moduleData, 'projectConfigById.twxEnabled', false));

  return { twxEnabled, twxLoading };
}
